/*
This file is located in the main branch
Last time the file was updated (UTC): [11/6/2024 4:35:58AM]
Permissions to update outside the main branch: [false]
*/

import { DropDown } from '@finbeat/react-toolkit';
import { SetWidgetLanguage } from 'base-components/WidgetCrm/WidgetClass';
import { useGeneralSettingsContext } from 'providers/GeneralSettingsProvider';
import { useMemo } from 'react';
import { setDefaultLocale } from 'react-datepicker';
import { useTranslation } from 'react-i18next';
import { MdLanguage } from 'react-icons/md';
import 'scss/Main.scss';
import SidebarSelector from '../Navigation/Sidebar/SidebarSelector/SidebarSelector';

type LanguageSelectorProps = {
    isSidebarCollapsed?: boolean;
};

export default function LanguageSelector({
    isSidebarCollapsed = false,
}: Readonly<LanguageSelectorProps>) {
    const { i18n } = useTranslation();
    const { cultures } = useGeneralSettingsContext();
    setDefaultLocale('en');
    const selectLang = ({ id }: DropDown<string>) => {
        if (!id) return;

        i18n.changeLanguage(id);
        setDefaultLocale(id);
        SetWidgetLanguage(id);
    };

    const value = useMemo(
        () => cultures.find((x) => x.code === i18n.language)?.name ?? '',
        [cultures, i18n.language]
    );

    return (
        <SidebarSelector<string>
            icon={<MdLanguage />}
            value={value}
            items={cultures.map<DropDown<string>>((x) => ({ id: x.code, name: x.name }))}
            onSelect={selectLang}
            isSidebarCollapsed={isSidebarCollapsed}
        />
    );
}
